"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _thirdSam = _interopRequireDefault(require("@/api/activity/thirdSam.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponEAct',
  components: {},
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newId, oldId) {
        // 避免初始化时的不必要调用
        if (newId === oldId && oldId !== undefined) return;
        console.log('actId', newId);
        if (newId) {
          this.fetchList();
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'detailUser'],
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      downloadLoading: false,
      searchForm: {
        keywords: '',
        type: '',
        timeRange: [],
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      // ...新增二维码相关状态...
      qrDialogVisible: false,
      qrImage: '',
      qrObj: {}
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    showCode: function showCode(row) {
      console.log('row', row);
      var url = 'http://api.gagacafe.com/exchange/' + row.id;
      console.log('url', url);

      // 使用第三方二维码生成服务（qrserver）
      var size = 500;
      var qrApi = "https://api.qrserver.com/v1/create-qr-code/?size=".concat(size, "x").concat(size, "&data=").concat(encodeURIComponent(url));

      // 直接将生成链接赋值给图片 src，弹窗显示
      this.qrImage = qrApi;
      this.qrObj = row;
      this.qrDialogVisible = true;
    },
    changeStatus: function changeStatus(id, status) {
      var _this = this;
      console.log('改变状态', id, status);
      _thirdSam.default.changeActStatus({
        id: id,
        status: status
      }).then(function (res) {
        _this.$message.success('状态修改成功');
        _this.fetchList();
      }).catch(function (err) {
        _this.$message.error('状态修改失败');
      });
    },
    addAct: function addAct() {
      this.$emit('addAct');
    },
    handleCoupon: function handleCoupon(row) {
      console.log('优惠券', row);
      this.$emit('handleCoupon', row);
    },
    handleEdit: function handleEdit(row) {
      this.$emit('handleEdit', row);
    },
    handleCopy: function handleCopy(row) {
      this.$emit('handleCopy', row);
    },
    detailUser: function detailUser(row) {
      this.$emit('detailUser', row);
    },
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
        console.log((0, _typeof2.default)(e[0]), e[0]);
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0];
        params.endTime = params.timeRange[1].replace('00:00:00', '23:59:59');
      }
      delete params.timeRange;
      _thirdSam.default.getProductList(params).then(function (res) {
        res.records.forEach(function (item) {
          if (item.createDate) {
            item.createDate = _this2.dateFormat2(item.createDate);
          }
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleDel: function handleDel(row) {
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664 ".concat(row.activityName, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // couponApi.deleteAct({ id: row.id }).then(res => {
        // this.$message.success('活动移除成功')
        //     this.fetchList()
        // }).catch(err => {
        //     this.$message.error('活动移除失败')
        // })
      }).catch(function () {
        // 取消操作
      });
    },
    download: function download() {
      var _this3 = this;
      this.downloadLoading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0];
        params.endTime = params.timeRange[1].replace('00:00:00', '23:59:59');
      }
      delete params.timeRange;
      delete params.page;
      delete params.limit;
      delete params.total;
      _thirdSam.default.exportProductList(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '商品列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this3.downloadLoading = false;
      });
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    }
  },
  created: function created() {
    this.fetchList();
  }
};